module.exports = __webpack_public_path__ + "img/主营业务_软件产品中心04.1cea3799.png";